import { FormGroup } from '@angular/forms';

export function ConfirmEmailValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmEmailValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmEmailValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
